import DemandeAdmissionInitiale from '../views/DemandeAdmissionInitiale.vue'
import RenseignementsGeneraux from '../components/DemandeAdmissionInitiale/RenseignementsGeneraux.vue'
import AutorisationDePratique from '../components/DemandeAdmissionInitiale/AutorisationDePratique.vue'
import DeclarationsObligatoires from '../components/DemandeAdmissionInitiale/DeclarationsObligatoires.vue'
import AttestationVeracite from '../components/DemandeAdmissionInitiale/AttestationVeracite.vue'
import InformationsComplementaires from '../components/DemandeAdmissionInitiale/InformationsComplementaires.vue'
import Formations from '../components/DemandeAdmissionInitiale/Formations.vue'
import AutresAutorisationsDePratique from '../components/DemandeAdmissionInitiale/AutresAutorisationsDePratique.vue'
import Langues from '../components/DemandeAdmissionInitiale/Langues.vue'

const routeName = "DemandeAdmissionInitiale"

export default [
  {
    path: '/demande-admission',
    component: DemandeAdmissionInitiale,
    meta: {
      title: 'Demande admission | OTSTCFQ'
    },
    props: {
      routeName: routeName,
    },
    children: [
      {
        path: "renseignements-generaux",
        name: `${routeName}/RenseignementsGeneraux`,
        component: RenseignementsGeneraux,
      },
      {
        path: "langues",
        name: `${routeName}/Langues`,
        component: Langues
      },
      {
        path: "formations",
        name: `${routeName}/Formations`,
        component: Formations
      },
      {
        path: "declarations-obligatoires",
        name: `${routeName}/DeclarationsObligatoires`,
        component: DeclarationsObligatoires
      },
      {
        path: "attestation-veracite",
        name: `${routeName}/AttestationVeracite`,
        component: AttestationVeracite
      },
      {
        path: "autres-autorisations-de-pratique",
        name: `${routeName}/AutresAutorisationsDePratique`,
        component: AutresAutorisationsDePratique
      },
      {
        path: "autorisation-de-pratique",
        name: `${routeName}/AutorisationDePratique`,
        component: AutorisationDePratique
      },
      {
        path: "informations-complementaires",
        name: `${routeName}/InformationsComplementaires`,
        component: InformationsComplementaires
      }
    ]
  }
]